import React, { useEffect, useMemo, useState } from 'react';
import { Card, Stack, Tab, Tabs } from '@mui/material';
import { hideLoader, showLoader } from '@utils/Loader';
import { showAlertError } from '@utils/Alerts/Error';
import { useSelector } from 'react-redux';
import { RootReducer } from '@store/index';
import ListInventory from '@screens/Cedis/Inventory/ListInventory';
import DistributionCenterService from '@api/DistributionCenters/DistributionCenterCtrl';
import { useNavigate } from 'react-router-dom';
import { hasPermission } from '@utils/Permissions';
import { ProfileTypes } from '@api/Users/User';
import ListInventoryHistory from '@screens/Cedis/Inventory/ListInventoryHistory';

const InventoryScreen: React.FunctionComponent = () => {
    const navigation = useNavigate();
    const { loggedUser, distributionCenterSelected } = useSelector((state: RootReducer) => state.auth);
    const distributionCenterService = useMemo(() => new DistributionCenterService(), []);
    const [currentDistributionCenterId, setCurrentDistributionCenterId] = useState<string | undefined>(undefined);

    const [activeTab, setActiveTab] = useState('inventory');

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setActiveTab(newValue);
    };

    const removeInputs = () => {
        if (currentDistributionCenterId) {
            navigation('removeInputs', { state: { distributionCenterId: currentDistributionCenterId } });
        }
    };

    const addInputs = () => {
        if (currentDistributionCenterId) {
            navigation('addInputs', { state: { distributionCenterId: currentDistributionCenterId } });
        }
    };

    const getData = async (distributionCenterId?: string, managerId?: string) => {
        showLoader();
        try {
            let id = distributionCenterId;
            if (managerId) {
                const distributionCenterData = await distributionCenterService.getDistributionCenterByManagerId(
                    managerId
                );
                id = distributionCenterData?.id;
            }
            setCurrentDistributionCenterId(id);
        } catch (error: any) {
            showAlertError(error);
        }
        hideLoader();
    };

    useEffect(() => {
        if (
            hasPermission([ProfileTypes.DistributionCenter]) &&
            loggedUser?.profile.profile !== ProfileTypes.Admin &&
            loggedUser?.uid
        ) {
            void getData(undefined, loggedUser?.uid);
        }
    }, [loggedUser]);

    useEffect(() => {
        if (distributionCenterSelected?.id) {
            void getData(distributionCenterSelected.id, undefined);
        }
    }, [distributionCenterSelected]);

    return (
        <Stack height="100%" spacing={2} p={2}>
            <Tabs value={activeTab} onChange={handleTabChange}>
                <Tab label="Inventario" value="inventory" />
                <Tab label="Historial de movimientos" value="history" />
            </Tabs>
            <Stack component={Card} flex={1}>
                {activeTab === 'inventory' && currentDistributionCenterId && (
                    <ListInventory
                        distributionCenterId={currentDistributionCenterId}
                        onAddInputs={addInputs}
                        onRemoveInputs={removeInputs}
                    />
                )}
                {activeTab === 'history' && currentDistributionCenterId && (
                    <ListInventoryHistory distributionCenterId={currentDistributionCenterId} />
                )}
            </Stack>
        </Stack>
    );
};
export default InventoryScreen;
